import _ from "../../../shared/utils/lodash";
var slugify = function (value) {
    // allow only basic latin alpha, numeric, / - _ and whitespace
    return _.deburr(value) // eslint-disable-line no-param-reassign
        .replace(/[^/-\w\s]/gi, "")
        .toLowerCase()
        .replace(/\s/g, "-"); // from rizzo next
};
export var createAdTargeting = function (dataLayer) {
    if (dataLayer === void 0) { dataLayer = {}; }
    if (Object.keys(dataLayer).length) {
        var dest = [
            "cd1_Continent",
            "cd2_Country",
            "cd3_City",
            "cd4_Neighborhood",
            "cd5_Region"
        ]
            .filter(function (item) { return dataLayer[item]; })
            .map(function (item) { return dataLayer[item]; }).join(",");
        return {
            city: slugify(dataLayer.cd3_City),
            cnty: slugify(dataLayer.cd2_Country),
            ctt: slugify(dataLayer.cd1_Continent),
            dest: dest,
            destination: dest,
            dfpkey: typeof window !== "undefined" && window.lp.ads
                ? window.lp.ads.dfpkey
                : null,
            interest: typeof window !== "undefined" && window.lp.ads
                ? window.lp.ads.interest
                : null,
            state: slugify(dataLayer.cd5_Region),
        };
    }
    return {};
};



//////////////////
// WEBPACK FOOTER
// ./app/modules/pois/utils/createAdTargeting.ts
// module id = 5HWx
// module chunks = 2